import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import {
  Form,
  Input,
  Button,
  DatePicker,
  Table,
  Radio,
  Spin,
  Select,
} from "antd";
import ListPagination, {
  LIST_DEFAULT_PAGE_SIZE,
  buildPageQuery,
  createPageChangeHandler,
  parseTotalFromPayload,
} from "../../components/ListPagination";
import API, { LIST_USER, LIST_ADMIN, LOCK_USER, UNLOCK_USER, LOCK_ADMIN, UNLOCK_ADMIN, LIST_USER_EXCEL } from "../../network/api";
import moment from "moment";
import "moment-timezone";
import { TEXT_DEF } from "../../constant/text";
import ModalCommon from "../../components/Modal";

const userStatusOp = [
  {
    key: 0,
    value: 'active',
    label: 'Hoạt động',
  },
  {
    key: 1,
    value: 'inactive',
    label: 'Khóa',
  }
]

const AccountList = () => {
  const auth = JSON.parse(localStorage.getItem("auth"));

  const [form] = Form.useForm();
  const [, forceUpdate] = useState({});
  const navigate = useNavigate();
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [userList, setUserList] = useState([]);
  const [adminList, setAdminList] = useState([]);
  const indexTabLocal = localStorage.getItem("indexTabAcc") || 1;
  const [indexTab, setIndexTab] = useState(Number(indexTabLocal));
  localStorage.removeItem("indexTabAcc");
  const [pageUser, setPageUser] = useState(1);
  const [pageSizeUser, setPageSizeUser] = useState(LIST_DEFAULT_PAGE_SIZE);
  const [totalRecordUser, setTotalRecordUser] = useState(0);
  const [pageAdmin, setPageAdmin] = useState(1);
  const [pageSizeAdmin, setPageSizeAdmin] = useState(LIST_DEFAULT_PAGE_SIZE);
  const [totalRecordAdmin, setTotalRecordAdmin] = useState(0);
  const locale = {
    emptyText: TEXT_DEF.text0035,
  };
  const [loading, setLoading] = useState(false);
  const [dataFilter, setDataFilter] = useState();
  const [userLock, setUserLock] = useState();

  const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
  const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);

  useEffect(() => {
    forceUpdate({});
  }, []);

  const getListDataUser = useCallback(async () => {
    setLoading(true);
    const URL = indexTab === 1 ? LIST_USER : LIST_ADMIN;
    const activePage = indexTab === 1 ? pageUser : pageAdmin;
    const activePageSize = indexTab === 1 ? pageSizeUser : pageSizeAdmin;
    const { query: pageQuery } = buildPageQuery(activePage, activePageSize);
    const dataList1 = API.get(
      `${URL}?${pageQuery}${dataFilter ? `&${dataFilter}` : ""}`
    );

    await Promise.all([dataList1])
      .then((response) => {
        const res = response[0].data?.data?.data;
        if (res) {
          let dataUserCV = [], dataAdminCV = [];

          res?.forEach((item) => {
            if (URL === LIST_USER) {
              const user = {
                key: item?.id,
                username: item?.username,
                userId: item?.id,
                createdAt: item?.createdAt,
                status: item?.status === "active" ? "Hoạt động" : item?.status === "inactive" ? "Khóa" : item?.status || "Không xác định",
              };
              dataUserCV.push(user);
              // dataUserCV = dataUserCV.sort((a, b) => (moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf()))
            } else if (URL === LIST_ADMIN) {
              const admin = {
                key: item?.id,
                id: item?.id,
                username: item?.username,
                role: item?.role,
                createdAt: item?.createdAt,
                updatedAt: item?.updatedAt,
                status: item?.status === "active" ? "Hoạt động" : item?.status === "inactive" ? "Khóa" : item?.status || "Không xác định",
              };
              dataAdminCV.push(admin);
            }
          });

          setUserList(dataUserCV);
          const pagePayload = response[0].data?.data;
          setTotalRecordUser(
            parseTotalFromPayload(pagePayload, dataUserCV.length)
          );

          setAdminList(dataAdminCV);
          setTotalRecordAdmin(
            parseTotalFromPayload(pagePayload, dataAdminCV.length)
          );
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, [pageUser, pageAdmin, pageSizeUser, pageSizeAdmin, dataFilter, indexTab]);

  useEffect(() => {
    getListDataUser();
  }, [getListDataUser]);

  const onChangePageUser = createPageChangeHandler(
    pageUser,
    pageSizeUser,
    setPageUser,
    setPageSizeUser
  );
  const onChangePageAdmin = createPageChangeHandler(
    pageAdmin,
    pageSizeAdmin,
    setPageAdmin,
    setPageSizeAdmin
  );

  const onSearch = () => {
    let params = '';
    if (form.getFieldValue("usernameFilter"))
      params += `username=${form.getFieldValue("usernameFilter").trim().toLowerCase()}`;
    if (form.getFieldValue("userStatus"))
      params += params !== '' ? `&status=${form.getFieldValue("userStatus")}` : `status=${form.getFieldValue("userStatus")}`;
    if (dateFrom) {
      params += params !== '' ? `&fromDate=${moment(dateFrom).format("YYYY-MM-DD")}` : `fromDate=${moment(dateFrom).format("YYYY-MM-DD")}`;
    }
    if (dateTo) {
      params += params !== '' ? `&toDate=${moment(dateTo).format("YYYY-MM-DD")}` : `toDate=${moment(dateTo).format("YYYY-MM-DD")}`;
      params += !dateFrom ? `&fromDate=${moment('2025-07-15').format("YYYY-MM-DD")}` : '';
    }

    if (indexTab === 1) {
      setPageUser(1);
    } else {
      setPageAdmin(1);
    }

    if (params !== '') {
      setDataFilter(params);
    } else {
      setDataFilter(null);
    }
  };

  const userColums = [
    {
      title: "STT",
      align: "center",
      key: "order",
      render: (text, record, index) => (
        <span>{(pageUser - 1) * 10 + (index + 1)}</span>
      ),
    },
    {
      title: TEXT_DEF.text0002,
      dataIndex: "username",
      key: "username",
    },
    {
      title: 'Thời gian truy cập lần đầu',
      key: "createdAt",
      render: (record) =>
        moment(record?.createdAt).utcOffset(7).format("DD-MM-YYYY HH:mm:ss"),
    },
    {
      title: 'Trạng thái',
      dataIndex: "status",
      key: "status",
    },
    {
      title: 'Hành động',
      key: "action",
      align: "center",
      render: (record) =>
        auth?.role === "super_admin" ? (
          <div className="flex flex-col w-full items-center justify-center">
            <p onClick={() => showModallockUser(record)} className="m-0 cursor-pointer" style={{ color: "rgb(22, 119, 255)" }}>{`${record.status === 'Hoạt động' ? 'Khóa' : 'Mở khóa'}`}</p>
            <p onClick={() => moveToHistory(record, 2)} className="m-0 cursor-pointer" style={{ color: "rgb(22, 119, 255)" }}>{`Xem lịch sử quy đổi`}</p>
            <p onClick={() => moveToHistory(record, 3)} className="m-0 cursor-pointer" style={{ color: "rgb(22, 119, 255)" }}>{`Xem lịch sử user tham gia`}</p>
            <p onClick={() => moveToHistory(record, 1)} className="m-0 cursor-pointer" style={{ color: "rgb(22, 119, 255)" }}>{`Xem lịch sử chơi`}</p>
          </div>
        ) : (
          <div className="flex flex-col w-full items-center justify-center">
            <p onClick={() => moveToHistory(record, 2)} className="m-0 cursor-pointer" style={{ color: "rgb(22, 119, 255)" }}>{`Xem lịch sử quy đổi`}</p>
            <p onClick={() => moveToHistory(record, 3)} className="m-0 cursor-pointer" style={{ color: "rgb(22, 119, 255)" }}>{`Xem lịch sử user tham gia`}</p>
            <p onClick={() => moveToHistory(record, 1)} className="m-0 cursor-pointer" style={{ color: "rgb(22, 119, 255)" }}>{`Xem lịch sử chơi`}</p>
          </div>
        ),
    },
  ];

  const adminColums = [
    {
      title: "STT",
      align: "center",
      key: "order",
      render: (text, record, index) => (
        <span>{(pageAdmin - 1) * 10 + (index + 1)}</span>
      ),
    },
    {
      title: TEXT_DEF.text0002,
      dataIndex: "username",
      key: "username",
    },
    {
      title: 'Trạng thái',
      dataIndex: "status",
      key: "status",
    },
    {
      title: 'Vai trò',
      dataIndex: "role",
      key: "role",
    },
    {
      title: 'Thời gian tạo',
      key: "createdAt",
      render: (record) =>
        moment(record?.createdAt).utcOffset(7).format("DD-MM-YYYY HH:mm:ss"),
    },
    {
      title: 'Thời gian cập nhật',
      key: "updatedAt",
      render: (record) =>
        moment(record?.updatedAt).utcOffset(7).format("DD-MM-YYYY HH:mm:ss"),
    },
    {
      title: "Hành động",
      key: "action",
      render: (text, record) =>
        auth?.role === "super_admin" ? (
          <div className="flex items-center justify-center">
            <p onClick={() => showModallockUser(record)} className="m-0 cursor-pointer" style={{ color: "rgb(22, 119, 255)" }}>{`${record.status === 'Hoạt động' ? 'Khóa' : 'Mở khóa'}`}</p>
          </div>
        ) : null,
    },
  ];

  const showModallockUser = async (record) => {
    setIsShowModalConfirm(true);
    setUserLock(record);
  }

  const lockUser = async () => {
    if (!userLock) return
    const URL = indexTab === 1 ?
      userLock?.status === "Hoạt động" ? LOCK_USER : UNLOCK_USER :
      userLock?.status === "Hoạt động" ? LOCK_ADMIN : UNLOCK_ADMIN;

    API.post(URL, { username: userLock?.username })
      .then((response) => {
        const responseData = response.data?.success;
        if (responseData) {
          setIsShowModalConfirm(false);
          setIsShowModalSuccess(true);
          getListDataUser();
        } else {
          console.log("Error locking/unlock user");
          setIsShowModalConfirm(false);
        }
      });
  }

  const moveToHistory = (record, type) => {
    const url =
      type === 1 ? "/gamingHis" : type === 2 ? "/conversionHis" : "/playHis";
    const username = String(record?.username ?? "").trim();
    if (username) {
      localStorage.setItem("usernameFilter", username);
    }
    navigate(url, { state: { usernameFilter: username } });
  };

  const onChangeDate = (e, type) => {
    if (e) {
      if (type === "from") setDateFrom(moment(e.$d).startOf("day").format('yyyy-MM-DD'));
      else setDateTo(moment(e.$d).endOf("day").format('yyyy-MM-DD'));
    } else {
      if (type === "from") setDateFrom(null);
      else setDateTo(null);
    }
  };

  const addNewAdmin = () => {
    localStorage.setItem("indexLocalCreate", indexTab);
    navigate("/createAccount");
  };

  const onChangeTab = (e) => {
    setPageUser(1);
    setPageAdmin(1);
    form.resetFields();
    setDataFilter(null);
    setIndexTab(e.target.value);
  };

  const handleDownloadExcel = async () => {
    // Thêm thông tin trạng thái vào request
    const requestBody = {
      includeStatus: true,
      statusMapping: {
        active: "Hoạt động",
        inactive: "Khóa"
      }
    };

    await API.post(
      `${LIST_USER_EXCEL}?${dataFilter ? `&${dataFilter}` : ""}`,
      requestBody,
      { responseType: 'blob' })
      .then(async (response) => {
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        // Optional: lấy tên file từ response header nếu có
        const disposition = response.headers.get('Content-Disposition');
        let fileName = 'hoi_vien.xlsx';
        if (disposition && disposition.includes('filename=')) {
          fileName = disposition.split('filename=')[1].replace(/"/g, '');
        }

        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const renderAccUser = () => {
    return (
      <>
        <div className="col-12">
          <Form
            form={form}
            layout="inline"
            autoComplete="off"
            onFinish={() => onSearch()}
          >
            <div
              className="col-12"
              style={{ marginBottom: 15, display: "flex" }}
            >
              <div className="col-5">
                <Form.Item name="usernameFilter" label={TEXT_DEF.text0002}>
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </div>
              <div className="col-5">
                <Form.Item name="userStatus" label={"Trạng thái"}>
                  <Select showSearch placeholder="" optionFilterProp="children" filterOption={''} options={userStatusOp} allowClear />
                </Form.Item>
              </div>
            </div>

            <div
              className="col-12"
              style={{ marginBottom: 15, display: "flex" }}
            >
              <div className="col-5">
                <Form.Item name="dateFrom" label={TEXT_DEF.text0032}>
                  <DatePicker
                    placeholder=""
                    onChange={(e) => onChangeDate(e, "from")}
                    format={"DD-MM-YYYY"}
                    style={{ width: "100%" }}
                    disabledTime={(d) =>
                      !d ||
                      d.isSameOrAfter(
                        dateTo ? moment(dateTo).add(1, "d") : moment()
                      )
                    }
                  />
                </Form.Item>
              </div>
              <div className="col-5">
                <Form.Item name="dateTo" label={TEXT_DEF.text0033}>
                  <DatePicker
                    placeholder=""
                    onChange={(e) => onChangeDate(e, "to")}
                    format={"DD-MM-YYYY"}
                    style={{ width: "100%" }}
                    disabledTime={(d) =>
                      !d ||
                      d.isSameOrBefore(dateFrom ? dateFrom : null) ||
                      d.isSameOrAfter(moment())
                    }
                  />
                </Form.Item>
              </div>
            </div>

            <div className="payment-search">
              <Button htmlType="submit" type="primary">
                {TEXT_DEF.text0031}
              </Button>
              <Button
                style={{ marginLeft: 20 }}
                onClick={handleDownloadExcel}
                htmlType="button"
                type="primary"
              >
                {TEXT_DEF.text0050}
              </Button>
            </div>
          </Form>
        </div>

        <Spin spinning={loading} delay={500} size="large">
          <div style={{ display: "flex", width: "100%", marginTop: 20 }}>
            <Table
              key="userList"
              locale={locale}
              columns={userColums}
              dataSource={userList}
              pagination={false}
              bordered
              style={{ width: "100%" }}
            />
          </div>
          <ListPagination
            current={pageUser}
            total={totalRecordUser}
            pageSize={pageSizeUser}
            onChange={onChangePageUser}
            unit="tài khoản"
          />
        </Spin>
      </>
    );
  };

  const renderAccAdmin = () => {
    return (
      <>
        <div className="col-12">
          <Form
            form={form}
            layout="inline"
            autoComplete="off"
            onFinish={() => onSearch()}
          >
            <div
              className="col-12"
              style={{ marginBottom: 15, display: "flex" }}
            >
              <div className="col-5">
                <Form.Item name="usernameFilter" label={TEXT_DEF.text0002}>
                  <Input style={{ width: "100%" }} />
                </Form.Item>
              </div>
              <div className="col-5">

                <Form.Item name="userStatus" label={"Trạng thái"}>
                  <Select showSearch placeholder="" optionFilterProp="children" filterOption={''} options={userStatusOp} allowClear />
                </Form.Item>
              </div>
            </div>

            <div
              className="col-12"
              style={{ marginBottom: 15, display: "flex" }}
            >
              <div className="col-5">
                <Form.Item name="dateFrom" label={TEXT_DEF.text0032}>
                  <DatePicker
                    placeholder=""
                    onChange={(e) => onChangeDate(e, "from")}
                    format={"DD-MM-YYYY"}
                    style={{ width: "100%" }}
                    disabledTime={(d) =>
                      !d ||
                      d.isSameOrAfter(
                        dateTo ? moment(dateTo).add(1, "d") : moment()
                      )
                    }
                  />
                </Form.Item>
              </div>
              <div className="col-5">
                <Form.Item name="dateTo" label={TEXT_DEF.text0033}>
                  <DatePicker
                    placeholder=""
                    onChange={(e) => onChangeDate(e, "to")}
                    format={"DD-MM-YYYY"}
                    style={{ width: "100%" }}
                    disabledTime={(d) =>
                      !d ||
                      d.isSameOrBefore(dateFrom ? dateFrom : null) ||
                      d.isSameOrAfter(moment())
                    }
                  />
                </Form.Item>
              </div>
            </div>

            <div className="payment-search">
              <Button htmlType="submit" type="primary">
                {TEXT_DEF.text0031}
              </Button>

              {auth?.role === "super_admin" && (<Button style={{ marginLeft: 20 }} type="primary" onClick={addNewAdmin}>
                {TEXT_DEF.text0010}
              </Button>)}
            </div>
          </Form>
        </div>

        <div style={{ display: "flex", width: "100%", marginTop: 20 }}>
          <Table
            key="listAdmin"
            locale={locale}
            columns={adminColums}
            dataSource={adminList}
            pagination={false}
            bordered
            style={{ width: "100%" }}
          />
        </div>
        <ListPagination
          current={pageAdmin}
          total={totalRecordAdmin}
          pageSize={pageSizeAdmin}
          onChange={onChangePageAdmin}
          unit="tài khoản"
        />
      </>
    );
  };

  return (
    <div className="col-12">
      {auth?.role === "super_admin" ? (
        <div
          className="col-12"
          style={{
            borderBottom: "1px solid #CCC",
            paddingBottom: "2rem",
            marginBottom: "2rem",
          }}
        >
          <Radio.Group value={indexTab} onChange={onChangeTab}>
            <Radio.Button value={1}>{TEXT_DEF.text0036}</Radio.Button>
            <Radio.Button value={2}>{TEXT_DEF.text0037}</Radio.Button>
          </Radio.Group>
        </div>
      ) : null}

      {indexTab === 1 ? renderAccUser() : renderAccAdmin()}
      {isShowModalConfirm && (
        <ModalCommon
          isShow={isShowModalConfirm}
          message={"Bạn có chắc chắn muốn cập nhật trạng thái tài khoản này?"}
          txtBtnAcc={TEXT_DEF.text0008}
          textBtnClose={TEXT_DEF.text0023}
          actionNext={() => lockUser()}
          close={() => setIsShowModalConfirm(false)}
        />
      )}
      {isShowModalSuccess && (
        <ModalCommon
          isShow={isShowModalSuccess}
          message={TEXT_DEF.text_modal_success}
          txtBtnAcc={TEXT_DEF.text0007}
          actionNext={() => {
            setIsShowModalSuccess(false);
          }}
          close={() => {
            setIsShowModalSuccess(false);
          }}
        />
      )}
    </div>
  );
};

export default AccountList;
